// Composes the URL we redirect to from `/search?q=…` when fulfilling a
// sitelinks-search-box query. The CX is the operator-supplied
// Programmable Search Engine identifier (see `env.cseCxId`); the search
// scope (avantfunded.com + trade.avantfunded.com) is configured in the
// CSE control panel at programmablesearchengine.google.com.
export function buildCseUrl(cseCxId: string, query: string): string {
  return `https://cse.google.com/cse?cx=${cseCxId}&q=${encodeURIComponent(query)}`;
}
